'use client'

import { Button } from '@comp/material'
import BorderColorIcon from '@mui/icons-material/BorderColor'
import { useCallback, useState } from 'react'
import { useSysMsg } from '@comp/sys-msg'
import { useTranslations } from 'next-intl'

export default function SendBar() {
  const ts = useTranslations('live')

  const { wsRef } = useSysMsg()
  const [text, setText] = useState('')

  const handSend = useCallback(
    (event) => {
      event.preventDefault()
      if (!text) return

      wsRef.current.sendRoom(text)
      setText('')
    },
    [text, setText, wsRef]
  )

  return (
    <div className="bg-primary p-pix-10">
      <form
        className="flex h-pix-50 items-center gap-x-pix-10 rounded-3xl bg-white px-pix-10"
        onSubmit={handSend}
      >
        <div className="flex min-w-0 flex-1 items-center gap-x-pix-10">
          <BorderColorIcon className="w-pix-16 fill-helper" />
          <input
            type="text"
            className="h-pix-40 flex-1 text-f.8 outline-none"
            placeholder={ts('saySomething')}
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </div>
        <Button type="submit" className="rounded-3xl">
          {ts('send')}
        </Button>
      </form>
    </div>
  )
}
